(function () {
    'use strict';
    var controllerId = '4a_pcRisorsaAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'pcRisorsa', 'corsoId', 'opInsert', 'cndTRisorse', 'tTitoloStudio', fn_4a_pcRisorsaAdd]);

    function fn_4a_pcRisorsaAdd($scope, $uibModalInstance, datacontext, pcRisorsa, corsoId, opInsert, cndTRisorse, tTitoloStudio) {
        //***
        $scope.cndTRisorse = cndTRisorse;
        $scope.tTitoloStudio = tTitoloStudio;
        $scope.validCF = true;
        $scope.checkCF = checkCF;

        if (pcRisorsa) {
            $scope.record = jQuery.extend({}, pcRisorsa); //Clona oggetto.
            $scope.Title = 'Modifica Risorsa (ID: ' + $scope.record.Id + ')';
            if (typeof $scope.record.CodiceFiscale != 'undefined' && $scope.record.CodiceFiscale.length > 0) {
                checkCF($scope.record.CodiceFiscale);
            }
        }
        else {
            $scope.Title = 'Nuova Risorsa';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CNDCorsoId = corsoId;
            $scope.record.OpInsert = opInsert;
            $scope.record.Deleted = false;
            $scope.record.iVersion = 1;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            //return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            console.log('openCalendar');
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1) {
                console.log('iOpened == 1');
                $scope.opened1 = true;
            }

        };

        $scope.clear = function ($event, iOpened) {
            console.log('clear');
            if (iOpened == 1) {
                //$scope.record.NascData = '';
                $scope.changed = true;
            }

        };

        $scope.format = "dd/MM/yyyy";



        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return item;
        }

        


        //Funzioni
        function checkCF(_value) {
            $scope.validCF = true;
            if (typeof _value == 'undefined') return;
            if (_value.length != 16) return;
            $scope.validCF = false;
            return datacontext.validazione_cf(_value, false).then(function (data) {
                return $scope.validCF = data;
            });
        }

    }
})();